export default __webpack_public_path__ + "static/media/stats.581b4059.svg";